import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout'

Vue.use(VueRouter)

function load (view) {
  return () => import(`@/views/${view}.vue`)
}

const otherRouter = {
  routes: [
    { path: '/login', component: load('Login'), hidden: true },
    {
      path: '/',
      component: Layout,
      // hidden: true,
      children: [{path: '/', name: 'CHANNEL', icon: 'el-icon-s-home', component: load('index')}]
    },
    {
      path: '/p',
      component: Layout,
      name: '名字',
      icon: 'el-icon-message',
      // subMenu: false,
      // hidden: true,
      children: [{path: '/p', name: '产品管理', icon: 'el-icon-s-management', component: load('OtherView/Product/index')}]
    },
    {
      path: '/l',
      component: Layout,
      name: '逻辑管理',
      icon: 'el-icon-message',
      subMenu: true,
      // hidden: true,
      children: [
        {path: '/l/login', name: '登录逻辑', icon: 'el-icon-s-management', component: load('OtherView/Logic/LoginLogic')},
        {path: '/l/pay', name: '支付逻辑', icon: 'el-icon-s-management', component: load('OtherView/Logic/PayLogic')}
      ]
    },
    {
      path: '/c',
      component: Layout,
      name: '渠道管理',
      icon: 'el-icon-message',
      subMenu: true,
      // hidden: true,
      children: [
        {path: '/c/login', name: '登录渠道', icon: 'el-icon-s-management', component: load('OtherView/Channel/LoginChannel')},
        {path: '/c/pay', name: '支付渠道', icon: 'el-icon-s-management', component: load('OtherView/Channel/PayChannel')}
      ]
    }
  ]
}

const router = new VueRouter(otherRouter)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js